import { useSearchParams } from "react-router-dom";
import { portfolioAnalysisPages } from "@app/const/route.const";
import { ModuleSectorAnalysisReport } from "./ModuleSectorAnalysisReport";

export const PdfPortfolioAnalysisSectorAnalysisReportPage = () => {
  const [searchParams] = useSearchParams();
  const { portfolioGroupId, moduleId, data1Id, data2Id, sectorFocusId } =
    portfolioAnalysisPages.getPdfSectorAnalysisReportParams(searchParams);

  return (
    <ModuleSectorAnalysisReport
      portfolioGroupId={portfolioGroupId}
      moduleId={moduleId}
      data1Id={data1Id}
      data2Id={data2Id}
      sectorFocusId={sectorFocusId}
      footer="Portfolio Analysis"
    />
  );
};
